export default "__VITE_ASSET__ed02be1d__"